
import { EventBus } from '@/utils/eventBus';
import MAP from '@/store/modules/MapModule';

export default {
	name: 'Dropdown',
	mixins: [],
	props: {
		value: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		selectedSizes: {
			type: Array,
			default: () => []
		},
		selectedPrice: {
			type: Number,
			default: 0
		},
		displayMode: {
			type: String,
			default: 'chips'
		}
	},
	data() {
		return {
			isOpen: false,
			selectedChips: [...this.value],
			contentWidth: 0
		};
	},
	computed: {
		headerStyle() {
			return {
				width: this.isOpen && this.contentWidth ? `${this.contentWidth - 72}px` : 'auto'
			};
		},
		currentPriceFilter() {
			return MAP.current_filter.max_price;
		}
	},

	watch: {
		value(newValue) {
			this.selectedChips = [...newValue];
		},
		// selectedPrice(newPrice) {
		// 	this.selectedPrice = newPrice;
		// },
		selectedSizes(newSizes) {
			this.selectedChips = [...newSizes];
		}
	},
	mounted() {
		this.$nextTick(this.updateHeaderWidth);
	},
	methods: {
		removeChip(chip) {
			const updatedChips = this.selectedChips.filter((c) => c !== chip);
			this.selectedChips = updatedChips;
			MAP.updateCurrentFilter({ ...MAP.current_filter, sizes: updatedChips });
			EventBus.$emit('fetch-trucks');
		},
		updateHeaderWidth() {
			// Add small delay to ensure content is rendered
			if (this.$refs.menuContent) {
				this.contentWidth = this.$refs.menuContent.offsetWidth;
			}
		},
		handleMenuState(isOpen) {
			this.isOpen = isOpen;
			setTimeout(() => {
				if (this.isOpen) {
					this.$nextTick(this.updateHeaderWidth);
				}
			}, 100);
		},
		toggleDropdown() {
			this.isOpen = !this.isOpen;
			setTimeout(() => {
				if (this.isOpen) {
					this.$nextTick(this.updateHeaderWidth);
				}
			}, 100);
		}
	}
};
